/**
 * Creates a new "Additional info" page.
 */
define([], () => ({dto, onQuote, markComplete, tileModel}) =>{
    function isValid() {
        return dto.email.aspects.valid && dto.age.aspects.valid && dto.termsChecked.aspects.valid;
    }
    return {
        dto,
        markComplete() {
            if (isValid()) {
                markComplete();
            }
        },
        quote() {
            if (isValid()) {
                onQuote();
            }
        },
        allStepsComplete() {
            return tileModel.completedSteps.slice(0, -1).every(isComplete => isComplete);
        }
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/additional/models/EditAdditionalInfo.js
 **/